// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-nos-services-js": () => import("./../../../src/pages/nos-services.js" /* webpackChunkName: "component---src-pages-nos-services-js" */),
  "component---src-pages-nous-joindre-js": () => import("./../../../src/pages/nous-joindre.js" /* webpackChunkName: "component---src-pages-nous-joindre-js" */)
}

